import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { ref: "getHeight" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "height" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "transition-expand",
        style: _normalizeStyle({ height: _ctx.height + "px" })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default")
        ], 512)
      ], 4)
    ]),
    _: 3
  }))
}